import { useEffect } from 'react';
import { z } from 'zod';
import { useConnectionStatus } from '../websocket/use-connection-status';
import { useStoreWebSocket } from '../websocket/use-store-websocket';
import { useTabId } from './use-tab-id';

// Owned by this hook, not by the WS layer: the register_tab payload schema.
// Matches the backend's expected shape. `session_id` is optional and must be
// omitted (not set to undefined) when the tab is not viewing a session.
const registerTabPayloadSchema = z.object({
  tab_id: z.string(),
  session_id: z.string().optional(),
});

export function useTabRegistration(sessionId?: string): void {
  const { send } = useStoreWebSocket();
  const status = useConnectionStatus();
  const tabId = useTabId();

  useEffect(() => {
    if (status !== 'open') {
      return;
    }

    send('register_tab', registerTabPayloadSchema, {
      tab_id: tabId,
      ...(sessionId ? { session_id: sessionId } : {}),
    });
  }, [status, sessionId, tabId, send]);
}
